import { differenceInDays } from 'date-fns';
export function getWorkingHoursForPersonForDate({ date, workingHoursByDay, personStartDate, personEndDate, }) {
    const dayIsBeforePersonStartDate = differenceInDays(personStartDate, date) > 0;
    const personEndDateIsBeforeDay = personEndDate && differenceInDays(date, personEndDate) > 0;
    if (dayIsBeforePersonStartDate || personEndDateIsBeforeDay)
        return 0;
    const workingHoursArray = Object.values(workingHoursByDay); // Array will have weekdays Sunday - Saturday on index 0 - 6
    return workingHoursArray[date.getDay()]; // Date.getDay returns Sunday - Saturday : 0 - 6, use this to access appropriate index in workingHoursArray
}
